import React, { useState, useEffect } from "react";

const BackgroundImageWithBlur = ({ src, children, className = "" }) => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!src) return;
    const img = new Image();
    img.src = src;
    img.onload = () => setIsLoading(false);
  }, [src]);

  return (
    <div
      className={`${className} transition-all duration-500`}
      style={{
        backgroundImage: src ? `url("${src}")` : "none",
        filter: isLoading ? "blur(20px)" : "blur(0)",
        transform: isLoading ? "scale(1)" : "scale(1)",
        backgroundPosition: "center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
      }}
    >
      {children}
    </div>
  );
};

export default BackgroundImageWithBlur;
